<template>
    <button
        :class="`watchlist-button add-button ${buttonType}`"
        type="button"
        @click.stop.prevent="addToWatchlist"
        v-if="canAdd"
    >
        <span><i class="material-icons">bookmark</i>Track</span>
    </button>

    <button
        class="watchlist-button tertiary remove-button"
        type="button"
        @click.stop.prevent="removeFromWatchlist"
        v-else-if="removeButtonEnabled && canRemove"
    >
        <li class="material-icons">verified_user</li>
        <span>Tracking</span>
    </button>
</template>
<script setup>
import { asyncComputed } from '@/utils/asyncComputed'
import { computed, inject } from 'vue'

const props = defineProps({
    entityType: {
        type: String,
    },
    entityId: {},
    removeButtonEnabled: {
        type: Boolean,
        default: true,
    },
    buttonType: {
        type: String,
        default: 'secondary',
    },
})

const store = inject('store')

const watchlist = computed(() => store.getters.watchlist)

const watchlists = asyncComputed(() => {
    if (props.entityId && props.entityType) {
        return watchlist.value.getWatchlistsForEntity(props.entityType, props.entityId)
    }
    return null
}, null)

const canAdd = computed(() => watchlists.value?.length === 0)
const canRemove = computed(() => watchlists.value?.length > 0)

const flash = inject('flash')

function addToWatchlist() {
    watchlist.value.addEntity(0, props.entityType, props.entityId).then(() => {
        flash('Added to TrackList.', null, { link: 'Undo', callback: removeFromWatchlist })
    })
}
function removeFromWatchlist() {
    watchlist.value.removeEntity(0, props.entityType, props.entityId).then(() => {
        flash('Removed from TrackList.', null, { link: 'Undo', callback: addToWatchlist })
    })
}
</script>
<style>
.profile-header {
    button.watchlist-button {
        width: 200px;
    }
}

.watchlist-button {
    &.remove-button {
        position: relative;
        border: 1px solid rgba(50, 49, 53, 0.1);

        .remove-link {
            background-color: var(--color-light);
            box-shadow: var(--boxshadow-default);
            font-size: 13px;
            left: 0px;
            line-height: 40px;
            padding: 0 24px;
            position: absolute;
            text-align: left;
            top: 32px;
            white-space: nowrap;
            z-index: var(--z-index-dropdown-menu);
        }

        &:hover {
            border: 1px solid rgba(50, 49, 53, 0.1);
            background-color: none;
            opacity: 1;
            span,
            li {
                display: none;
            }

            &:before {
                color: rgba(50, 49, 53, 0.64);
                opacity: 0.75;
                content: 'Stop Tracking';
            }
        }
    }

    &.small {
        .material-icons {
            display: none;
        }
    }
}

.watchlist {
    button {
        width: 240px;
    }

    .remove-button {
        position: relative;

        border: 1px solid #e4e3e8;
        .material-icons {
            font-size: 18px;
            margin-right: 0;
            position: absolute;
            left: 16px;
            top: -4px;
        }
        .remove-link {
            background-color: var(--color-light);
            box-shadow: var(--boxshadow-default);
            font-size: 13px;
            left: 0px;
            line-height: 40px;
            padding: 0 24px;
            position: absolute;
            text-align: left;
            top: 32px;
            white-space: nowrap;
            z-index: var(--z-index-dropdown-menu);
        }
    }
}
</style>
